import { useTranslation } from 'react-i18next'
import styles from './Navbar.module.css'

interface NavbarProps {
  onMenuToggle: () => void
}

export function Navbar({ onMenuToggle }: NavbarProps) {
  const { i18n } = useTranslation()

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
  }

  return (
    <nav className={styles.navbar}>
      <button
        className={styles.menuButton}
        onClick={onMenuToggle}
        aria-label="Toggle menu"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      <div className={styles.spacer} />

      <div className={styles.langSwitch}>
        {(['fr', 'en', 'de'] as const).map(lng => (
          <button
            key={lng}
            className={`${styles.langButton} ${i18n.language === lng ? styles.langActive : ''}`}
            onClick={() => changeLanguage(lng)}
          >
            {lng.toUpperCase()}
          </button>
        ))}
      </div>
    </nav>
  )
}
